import React, { Component } from 'react';
import { connectStateResults } from 'react-instantsearch/connectors';
import { InstantSearch } from 'react-instantsearch/dom';
import { css } from 'react-emotion';

const AlgoliaRootStyle = css`
  width: inherit;
  height: inherit;
`;

class StateResults extends Component {
  render() {
    const { searching, searchResults } = this.props;

    let hits;
    let hasHits;
    if (searchResults && searchResults.hits) {
      hasHits = searchResults.hits.length > 0;
      hits = searchResults.hits;
    }

    return this.props.children({ searching, hasHits, hits });
  }
}

export const ConnectedStateResults = connectStateResults(StateResults);

export default class AlogoliaWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchState: {},
    };
  }

  filterReset = () => {
    this.setState(() => ({
      searchState: {},
    }));
  };

  onSearchStateChange = nextSearchState => {
    const { searchState } = this.state;
    this.setState({
      searchState: { ...searchState, ...nextSearchState },
    });
  };

  render() {
    const { filterReset } = this;
    const { searchState } = this.state;
    const { appID, apiKey, indexName, render } = this.props;
    return (
      <InstantSearch
        appId={appID}
        apiKey={apiKey}
        indexName={indexName}
        root={{
          Root: 'div',
          props: { className: AlgoliaRootStyle },
        }}
        onSearchStateChange={this.onSearchStateChange}
        searchState={searchState}
      >
        {render({
          filterReset,
        })}
      </InstantSearch>
    );
  }
}



// WEBPACK FOOTER //
// ../shop_main/components/algoliawrapper/index.js